module.exports = __webpack_public_path__ + "static/power-img3-1-81cbfeab9f8613d8335aa8c35ca52b53.png";